export default class CashPointSelect {
    text = '';
    value = 1;
}